module.exports = __webpack_public_path__ + "img/p4.d98d6c8f.png";